var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WidgetCard',{attrs:{"title":"FÖRETAG UTAN AVTAL","subtitle":"ATT GRANSKA, GODKÄNNA ELLER BEKRÄFTA"}},[_c('v-data-table',{class:'clickable',attrs:{"hide-default-footer":"","headers":[
    { text: 'Företagsnamn', value: 'name' },
    { text: 'Org.nr.', value: 'organizationalNumber' },
    { text: 'Avtalstyp', value: 'contracttype.name' },
    { text: 'Tidigare avtalstyp', value: 'previousAgreementStatus' },
    { text: 'Postnr', value: 'postalZip' },
    { text: 'Ort', value: 'postalCity' } ],"items":_vm.items,"items-per-page":-1,"server-items-length":_vm.totalRows,"item-key":"id"},on:{"click:row":_vm.showCompany}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }